"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpenetrableDefenseAbilityHandler = exports.ImpenetrableDefenseActorAbilityFactory = exports.ImpenetrableDefenseAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/effects/core");
class ImpenetrableDefenseAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ImpenetrableDefense;
        this.__typeName = "ImpenetrableDefense";
    }
}
exports.ImpenetrableDefenseAbilityArgs = ImpenetrableDefenseAbilityArgs;
let ImpenetrableDefenseActorAbilityFactory = class ImpenetrableDefenseActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ImpenetrableDefense", "Self", 4);
    }
};
ImpenetrableDefenseActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ImpenetrableDefense")
], ImpenetrableDefenseActorAbilityFactory);
exports.ImpenetrableDefenseActorAbilityFactory = ImpenetrableDefenseActorAbilityFactory;
let ImpenetrableDefenseAbilityHandler = class ImpenetrableDefenseAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const additionalEffects = Array.of();
        if (container.hasAttribute(ability.invokerId, "Charm_Monk_0")) {
            additionalEffects.push(new core_1.BlockEffectArgs());
        }
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(targetId => container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Toughness, container.getPercentOfBaseAttributeScore(ability.invokerId, 10, "Toughness")),
                        new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Will, container.getPercentOfBaseAttributeScore(ability.invokerId, 10, "Will")),
                        ...additionalEffects
                    ], false)
                }));
            }
        });
    }
};
ImpenetrableDefenseAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ImpenetrableDefense)
], ImpenetrableDefenseAbilityHandler);
exports.ImpenetrableDefenseAbilityHandler = ImpenetrableDefenseAbilityHandler;
